module.exports = __webpack_public_path__ + "img/Shirobon.28dbbed3.jpg";